<!-- Generator: Adobe Illustrator 25.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg
  version="1.1"
  id="Layer_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  viewBox="0 0 353 267"
  style="enable-background: new 0 0 353 267"
  xml:space="preserve"
>
  <g>
    <path
      class="st0"
      d="M193.79,217.2c-10.32,0.49-20.1,1.44-28.91,2.73l0.01,0c0,0-32.18,4.14-54.58,6.5
		c-22.4,2.36-34.07-8.25-58.94-8.25c-35.37,0-41.77,24.96-15.33,18.86c30.65-7.07,80.35,2.62,97.84,7.07l0.09-0.07
		c12.76,3.96,35.58,5.92,61.46,4.7c39.44-1.87,71.04-10.44,70.59-19.14C265.56,220.88,233.22,215.34,193.79,217.2z"
    />
    <g>
      <path
        class="st1"
        d="M170.81,57.88C99.66,89.71,91.26,23.49,50.79,41.06c-18.18,7.89-26.61,27.93-29.15,36.65
			c-0.7,2.41,1.49,4.7,4.07,4.26c4.95-0.86,9.67-1.53,16.53-1.56c1.23-0.01,0.79,1.01,0.12,2.74
			c-8.52,22.01-26.16,27.07-27.75,54.54c-2.13,36.89,17.77,57.46,36.47,71.19c1.95,1.43,4.93,1.74,6.2-0.26
			c51.71-81.25,92.87-36.61,112.23-108.09C167.53,91.72,170.81,57.88,170.81,57.88z"
      />
      <path
        class="st2"
        d="M52.93,57.78c-1.69-0.11,12.77-7.36,24.62-1.16s16.81,9.3,27.8,12.98c10.99,3.68,22.99,4.61,22.99,4.61
			s-19.54,3.06-33.66-0.86C74.32,67.7,79.21,59.45,52.93,57.78z"
      />
      <path
        class="st3"
        d="M38.77,165.51c-3.92-0.91,7.3-22.24,24.7-28.09c23.87-8.03,32.03-8.31,44.38-20.4
			c-12.14,16.74-18.54,21.99-38.63,32.32C57.27,155.49,51.43,148.38,38.77,165.51z"
      />
      <g>
        <defs>
          <path
            id="SVGID_1_"
            d="M170.81,57.88C99.66,89.71,91.26,23.49,50.79,41.06c-18.18,7.89-26.61,27.93-29.15,36.65
					c-0.7,2.41,1.49,4.7,4.07,4.26c4.95-0.86,9.67-1.53,16.53-1.56c1.23-0.01,0.79,1.01,0.12,2.74
					c-8.52,22.01-26.16,27.07-27.75,54.54c-2.13,36.89,17.77,57.46,36.47,71.19c1.95,1.43,4.93,1.74,6.2-0.26
					c51.71-81.25,92.87-36.61,112.23-108.09C167.53,91.72,170.81,57.88,170.81,57.88z"
          />
        </defs>
        <clipPath id="SVGID_2_">
          <use xlink:href="#SVGID_1_" style="overflow: visible" />
        </clipPath>
        <path
          class="st4"
          d="M94.71,86.57c-6.15,14.35-40.83,8.24-59.98,27.34c-13.01,12.97-18.03,38.41-7.08,63.36
				c6.08,13.87,9.52,11.55,21.28,1.37c9.8-8.5,15.89-16.93,37.02-26.41c31.63-14.19,54.92-44.2,65.74-65.79
				c10.82-21.59,16.61,50.78,16.61,50.78L58.64,228.15c0,0-62.74-8.2-65.98-56.55s5.11-79.01,5.11-79.01l41.38-12.12
				C39.15,80.47,78.69,85.95,94.71,86.57z"
        />
      </g>
      <path class="st5" d="M42.24,80.4c13.91-0.69,17.62,6.17,50.9,5.71" />
      <path class="st6" d="M37.83,163.99c19.85-42.49,49.76-19.17,74.04-54.74" />
      <path
        class="st6"
        d="M170.81,57.88C99.66,89.71,91.26,23.49,50.79,41.06c-18.18,7.89-26.61,27.93-29.15,36.65
			c-0.7,2.41,1.49,4.7,4.07,4.26c4.95-0.86,9.67-1.53,16.53-1.56c1.23-0.01,0.79,1.01,0.12,2.74
			c-8.52,22.01-26.16,27.07-27.75,54.54c-2.13,36.89,17.77,57.46,36.47,71.19c1.95,1.43,4.93,1.74,6.2-0.26
			c51.71-81.25,92.87-36.61,112.23-108.09C167.53,91.72,170.81,57.88,170.81,57.88z"
      />
      <path class="st6" d="M52.98,56.3c16.43-6.99,27.77,3.32,45.75,10.87c17.11,7.18,29.21,5.5,29.21,5.5" />
    </g>
    <g>
      <path
        class="st7"
        d="M298.55,83.01c-2.62,3.92-14.45,6.48-20.67,7.47c-15.81,2.53-31.44,2.37-35.37,1.88
			c-2.99-0.37-5.23-3.76-3.48-6.81c1.45-2.51,4.7-5.48,8.36-5.23c1.57,0.11,16.3,2.62,31.55,1.25
			C282.39,81.28,300.2,80.54,298.55,83.01z"
      />
    </g>
    <path
      class="st8"
      d="M194.89,213.05c0,0-10.4,10.86-14.77,15.79c-1.47,1.66-2.74,3.5-2.76,5.53c-0.02,2.26-0.51,3.55-1.89,3.96
		c-5.06,1.49-10.19,1.5-13.38,1.48c-2.99-0.03-2.33-5.23,1.36-8.1c1.91-1.48,3.37-2.31,4.35-2.76c0.91-0.42,1.55-1.25,1.69-2.24
		l2.09-14.15"
    />
    <path
      class="st8"
      d="M203.45,210.53c0,0,9.81,6.97,13.41,11.71c1.27,1.67,1.74,3.91,1.65,5.56c-0.07,1.31,1.01,2.38,2.31,2.31
		c4.86-0.27,9.87-1.35,12.73-2.86c2.31-1.22,1.63-4.68-1.77-6.63c-1.5-0.87-2.94-1.15-4.07-1.19c-1.4-0.05-2.57-1.08-2.7-2.47
		l-1.35-13.73"
    />
    <path
      class="st9"
      d="M135.39,89.54c8.71,32.89,15.75,55.72,12.97,97.9c-1.05,15.98,3.48,23.1,10.93,27.11
		c7.36,3.96,14.84,4.8,19.48,4.49c13.2-0.87,27.55-5.34,40.23-10.27c11.7-4.56,19.15-13.19,22.26-24.59
		c11.22-41.17,16.3-89.23,6.84-130.47c-2.82-12.27-14.58-19.11-28.13-18.64c-16.74,0.59-43.91,4.76-62.19,11.75
		C138.09,54.34,130.81,72.25,135.39,89.54z"
    />
    <g class="st10">
      <path
        class="st11"
        d="M248.17,61.09c-0.35-1.77-0.73-3.53-1.13-5.27c-2.3-9.86-10.18-14.16-20.74-13.42
			c-17.69,1.24-41.13,6.49-57.26,11.16c-13.32,3.86-19.43,18.48-16.47,31.46c7.12,31.32,11.21,69.12,7.71,113.55
			c-0.97,12.2,7.13,19.24,16.18,19.05c12.97-0.28,28.35-4.61,42.31-10.21c11.19-4.49,18.5-13.02,21.32-23.49
			C251.13,142.97,255.69,99.03,248.17,61.09z M203.77,52.39c-4.36,0.66-6.77,1.17-10.05,2.03c-0.88,0.23-2.24,0.29-2.37-1.04
			c-0.14-1.41,1.08-2.02,1.96-2.28c3.62-1.08,6.42-1.56,10.56-2.11c0.09-0.01,0.19-0.02,0.29-0.01c0.84-0.04,1.73,0.17,1.69,1.34
			C205.8,51.71,204.68,52.25,203.77,52.39z M209.98,51.2c-0.95,0-1.72-0.78-1.72-1.73s0.77-1.72,1.72-1.72s1.72,0.77,1.72,1.72
			S210.93,51.2,209.98,51.2z"
      />
    </g>
    <path
      class="st12"
      d="M160.53,90.51c5.03,30.85,7.96,64.64,5.62,94.39c-0.77,9.82,6.9,16.19,15.33,15.51
		c12.65-1.02,25.88-4.51,38.92-9.76c9.76-3.93,16.57-12.56,19.1-22.4c8.49-33.03,10.26-69.33,5.55-101.42
		c-1.46-9.96-8.77-15.3-18.64-14.61c-16.52,1.16-38.11,5.44-53.18,9.82C160.79,65.64,158.52,78.2,160.53,90.51z"
    />
    <path
      class="st11"
      d="M173.78,154.97c-0.88,8.13-1.14,20.67-0.44,29.05c0.47,5.65,2.21,9.35,12.28,8.17s23.61-5.72,26.55-6.5
		c5.35-1.42,5.08-5.29,1.4-4.94c-5.63,0.55-22.11,2.3-27.08,1.51s-7.92-0.69-8.06-8.2c-0.14-7.51,0.3-18.22-0.53-21.64
		C177.07,148.98,174.39,149.34,173.78,154.97z"
    />
    <path
      class="st13"
      d="M185.93,186.92c-12.21,2.22-21.59,0.56-25.2-0.72c-4.3-1.52-9.25-6.43-9.25-6.43l-9.25-4.35
		c0,0-3.75,7.88,0.09,19.62c1.7,5.2,8.81,11.42,20.24,12.32s22.35,0.21,32.38-1.45c7.81-1.29,20.16-3.96,26.44-5.92
		c4.39-1.37,12.5-5.28,18.08-8.59c2.97-1.76,8.51-4.18,11.01-12.31c2.99-9.74,1.1-18.49-2.52-19.62c-0.35,0.9-1.43,8.76-3.05,10.14
		c-4.14,3.51-11.37,7.95-21.39,10.17C207.86,183.22,185.93,186.92,185.93,186.92z"
    />
    <path
      class="st13"
      d="M185.93,186.92c-2.28,0.41-4.45,0.69-6.51,0.86l-2.43,3.31c-2.54,3.46-2.28,8.04,0.6,10.65l6.11,5.55
		c3.85-0.32,7.6-0.79,11.22-1.39c7.81-1.29,20.16-3.96,26.44-5.92c0.55-0.17,1.16-0.39,1.82-0.63l4.76-6
		c2.65-3.34,2.59-7.92-0.13-10.67l-3.15-3.19c-0.39,0.09-0.78,0.19-1.17,0.28C207.86,183.22,185.93,186.92,185.93,186.92z"
    />
    <path
      class="st13"
      d="M158.21,185c-3.5-2.03-6.73-5.23-6.73-5.23l-9.25-4.35c0,0-3.75,7.88,0.09,19.62
		c1.55,4.74,7.61,10.31,17.32,11.95C157.11,199.27,157.68,189.8,158.21,185z"
    />
    <g>
      <ellipse
        transform="matrix(0.7785 -0.6277 0.6277 0.7785 -64.8567 105.0612)"
        class="st14"
        cx="116.41"
        cy="144.41"
        rx="17.5"
        ry="4.67"
      />
      <g>
        <path
          class="st15"
          d="M151.06,118.13c-2.61-0.57-6.54-0.34-9.52,0.49c-5.6,1.57-11.91,4.17-18.76,11.36
				c-2.22,2.33-3.62,5.36-3.47,6.89c0.22,2.27-0.02,7.97,12.02,15.44c3.02,1.87,6.06,3.41,4.13,6.28c-1.46,2.17-4.11,3.16-6.61,2.71
				c-0.82-0.15-1.62-0.45-2.36-0.91c-9.85-6.11-18.47-13.47-19.4-23.18c-0.53-5.54,2-10.03,6.95-15.45
				c9.57-10.48,18.88-13.99,24.92-18.84c3.76-3.02,5.38-4.84,6.46-7.36"
        />
      </g>
      <path
        class="st16"
        d="M150.92,158.39c-2.27-0.7-3.27-0.11-6.41,2.45c-7.44-7.83-8.04-19.54-14.51-27.46
			c1.72,1.93-2.97,8.43-10.47,14.52c-6.95,5.65-13.87,8.95-16.22,7.88c8.41,5.95,23.29,12,29.15,14.95c5.96,3,7.73,6.66,11.32,9.19
			c5.16,3.63,11.45,3.93,13.38-1.98c1.32-4.06,1.71-6.08,2.06-8.81c0.36-2.75,0.1-5.43-1.63-6.95
			C155.83,160.64,153.72,159.25,150.92,158.39z"
      />
      <g>
        <defs>
          <path
            id="SVGID_3_"
            d="M150.92,158.39c-2.27-0.7-3.27-0.11-6.41,2.45c-7.44-7.83-8.04-19.54-14.51-27.46
					c1.72,1.93-2.97,8.43-10.47,14.52c-6.95,5.65-13.87,8.95-16.22,7.88c8.41,5.95,23.29,12,29.15,14.95
					c5.96,3,7.73,6.66,11.32,9.19c5.16,3.63,11.45,3.93,13.38-1.98c1.32-4.06,1.71-6.08,2.06-8.81c0.36-2.75,0.1-5.43-1.63-6.95
					C155.83,160.64,153.72,159.25,150.92,158.39z"
          />
        </defs>
        <clipPath id="SVGID_4_">
          <use xlink:href="#SVGID_3_" style="overflow: visible" />
        </clipPath>
        <path
          class="st17"
          d="M124.5,142.92c2.52,3.34,8.22,11.77,11.09,14.64c2.87,2.87,7.08,7.01,9.75,7.21
				c2.65,0.2,9.48-0.61,9.02,4.94c-0.25,2.98-0.16,14.58-7.63,11.59c-7.47-3,4.11,5.88,4.11,5.88s10.26,2.26,10.82,0.81
				c0.55-1.45,3.36-33.69,3.36-33.69l-17.28-1.12l-18.18-25.1L124.5,142.92z"
        />
      </g>
      <path
        class="st6"
        d="M150.92,158.39c-2.27-0.7-3.27-0.11-6.41,2.45c-7.44-7.83-8.04-19.54-14.51-27.46
			c1.72,1.93-2.97,8.43-10.47,14.52c-6.95,5.65-13.87,8.95-16.22,7.88c8.41,5.95,23.29,12,29.15,14.95c5.96,3,7.73,6.66,11.32,9.19
			c5.16,3.63,11.45,3.93,13.38-1.98c1.32-4.06,1.71-6.08,2.06-8.81c0.36-2.75,0.1-5.43-1.63-6.95
			C155.83,160.64,153.72,159.25,150.92,158.39z"
      />
    </g>

    <ellipse
      transform="matrix(0.9887 -0.1498 0.1498 0.9887 -12.5542 28.3045)"
      class="st18"
      cx="181.64"
      cy="97.5"
      rx="12.99"
      ry="7.72"
    />

    <ellipse
      transform="matrix(0.9887 -0.1498 0.1498 0.9887 -9.9893 36.1869)"
      class="st18"
      cx="235.25"
      cy="84.41"
      rx="9.27"
      ry="5.51"
    />
    <path
      class="st19"
      d="M203.71,152c-3.49-1.59-6.74-1.64-9.78-0.72c1.74,3.23,4.33,6.21,8.18,7.89c3.43,1.5,6.6,1.53,9.57,0.63
		C209.98,156.63,207.46,153.71,203.71,152z"
    />
    <path
      class="st20"
      d="M229.75,144.51c-18.66,25.92-37.52,18.84-37.07-5.65C193.97,152.39,214.42,155.93,229.75,144.51z"
    />
    <path class="st20" d="M196.3,135.21c0,0-2.89,2.21-7.61,3.39" />
    <g>
      <g>
        <path
          class="st11"
          d="M204.25,217.9c-1.17,0-2.23-0.4-3.07-1.17l-19.68-17.87c-1.97-1.79-2.1-5.12-0.29-7.58l5.05-6.89
				c0.96-1.31,2.36-2.21,3.83-2.47l29.27-5.16c0.29-0.05,0.59-0.08,0.88-0.08c1.25,0,2.41,0.48,3.26,1.34l5.05,5.11
				c1.87,1.89,1.85,5.23-0.04,7.62l-19.68,24.81c-0.96,1.21-2.27,2.02-3.67,2.27C204.85,217.88,204.55,217.9,204.25,217.9z"
        />
        <path
          class="st13"
          d="M220.24,177.91c0.91,0,1.76,0.34,2.38,0.97l5.05,5.11c1.44,1.45,1.38,4.09-0.13,5.99l-19.68,24.81
				c-0.78,0.98-1.82,1.63-2.92,1.82c0,0,0,0,0,0c-0.23,0.04-0.46,0.06-0.68,0.06c-0.85,0-1.63-0.29-2.24-0.85l-19.68-17.87
				c-1.51-1.37-1.57-3.98-0.13-5.94l5.05-6.89c0.78-1.06,1.89-1.78,3.05-1.99l29.27-5.16C219.79,177.93,220.02,177.91,220.24,177.91
				 M220.24,175.45c-0.36,0-0.73,0.03-1.09,0.1l-29.27,5.16c-1.78,0.31-3.46,1.39-4.61,2.96l-5.05,6.89
				c-2.17,2.96-1.97,7.01,0.46,9.22l19.68,17.87c1.06,0.96,2.44,1.49,3.9,1.49c0.37,0,0.74-0.03,1.11-0.1
				c1.7-0.3,3.27-1.26,4.42-2.71l19.68-24.81c2.31-2.91,2.29-6.88-0.05-9.25l-5.05-5.11C223.28,176.05,221.82,175.45,220.24,175.45
				L220.24,175.45z"
        />
      </g>
      <g>
        <path
          class="st1"
          d="M224.25,189.32l-17.52,22.08c-0.98,1.24-2.6,1.53-3.58,0.63l-17.52-15.91c-0.93-0.84-0.96-2.44-0.08-3.64
				l3.59-4.9c0.48-0.65,1.16-1.09,1.87-1.22l13.93-2.46l13.93-2.46c0.71-0.13,1.39,0.08,1.87,0.56l3.59,3.63
				C225.21,186.54,225.17,188.15,224.25,189.32z M204.93,181.46l-14.63,2.58c-0.92,0.16-1.79,0.73-2.41,1.57l-5.05,6.89
				c-1.14,1.55-1.09,3.61,0.1,4.69l19.68,17.87c1.27,1.15,3.35,0.78,4.62-0.81l19.68-24.81c1.2-1.51,1.24-3.58,0.1-4.73l-5.05-5.11
				c-0.61-0.62-1.49-0.88-2.41-0.72L204.93,181.46z"
        />
        <path
          class="st1"
          d="M204.93,216.61C204.93,216.61,204.93,216.61,204.93,216.61c-1.11,0.2-2.15-0.09-2.92-0.79l-19.68-17.87
				c-1.51-1.37-1.57-3.98-0.13-5.94l5.05-6.89c0.78-1.06,1.89-1.78,3.05-1.99l29.27-5.16c1.16-0.21,2.28,0.13,3.05,0.91l5.05,5.11
				c1.44,1.45,1.38,4.09-0.13,5.99l-19.68,24.81C207.08,215.77,206.04,216.42,204.93,216.61z M190.3,184.96
				c-0.67,0.12-1.32,0.54-1.77,1.15l-5.05,6.89c-0.83,1.14-0.8,2.65,0.07,3.44l19.68,17.87c0.45,0.41,1.05,0.57,1.69,0.46l0,0
				c0.64-0.11,1.24-0.49,1.69-1.05l19.68-24.81c0.87-1.1,0.91-2.62,0.07-3.47l-5.05-5.11c-0.45-0.45-1.09-0.65-1.77-0.53
				L190.3,184.96z M204.93,213.44c-0.91,0.16-1.77-0.07-2.41-0.65l-17.52-15.91c-1.24-1.13-1.29-3.28-0.11-4.9l3.59-4.9
				c0.64-0.87,1.56-1.47,2.51-1.64l27.86-4.91c0.96-0.17,1.87,0.11,2.51,0.75l3.59,3.63c1.18,1.2,1.14,3.37-0.11,4.93l-17.52,22.09
				C206.7,212.75,205.85,213.28,204.93,213.44z M191.01,187.29c-0.47,0.08-0.92,0.37-1.23,0.8l-3.59,4.9
				c-0.58,0.79-0.56,1.84,0.05,2.39l17.52,15.91c0.62,0.57,1.73,0.37,2.35-0.41l17.52-22.09c0.61-0.77,0.63-1.82,0.05-2.41
				l-3.59-3.63c-0.31-0.32-0.76-0.45-1.23-0.37L191.01,187.29z"
        />
      </g>
      <g>
        <g>
          <path
            class="st1"
            d="M201.98,193.34c-0.31,0.05-0.56-0.19-0.59-0.55c-0.01-0.1-0.02-0.18-0.03-0.27c0-0.33-0.05-1.11-0.38-1.62
					c-0.15-0.23-0.34-0.4-0.57-0.53c-0.23-0.13-0.51-0.15-0.86-0.07c-0.68,0.16-1.22,0.36-1.61,0.62c-0.39,0.26-0.68,0.58-0.86,0.97
					c-0.24,0.5-0.4,1.1-0.49,1.82c-0.08,0.71-0.11,1.52-0.08,2.4c0.03,0.73,0.08,1.46,0.15,2.19c0.07,0.73,0.22,1.35,0.46,1.85
					c0.15,0.32,0.39,0.57,0.71,0.74c0.32,0.17,0.77,0.19,1.35,0.05c0.5-0.12,0.89-0.31,1.18-0.56c0.29-0.25,0.9-1.13,1.04-2.13
					l-2.24,0.26c-0.44,0.05-0.77-0.32-0.75-0.84l0.09-1.68c0.03-0.52,0.41-0.99,0.86-1.03l2.04-0.21l2.9-0.28l0.3-0.04
					c0.48-0.06,0.86,0.34,0.85,0.9c-0.01,0.23-0.01,0.44-0.01,0.54c-0.01,1.07-0.13,2.13-0.34,3.18c-0.21,1.05-0.56,2.02-1.03,2.9
					c-0.48,0.88-1.1,1.64-1.87,2.28c-0.77,0.64-1.73,1.08-2.88,1.32c-0.77,0.17-1.46,0.22-2.07,0.16c-0.61-0.07-1.15-0.22-1.63-0.46
					c-0.47-0.24-0.89-0.57-1.24-0.98c-0.35-0.41-0.65-0.87-0.89-1.39c-0.42-0.87-0.69-1.83-0.81-2.87c-0.12-1.04-0.2-2.05-0.23-3.03
					c-0.03-1.31,0.04-2.54,0.2-3.7c0.17-1.16,0.49-2.23,0.97-3.23c0.56-1.13,1.29-2.07,2.21-2.82c0.92-0.75,2.11-1.28,3.58-1.59
					c1.06-0.22,1.95-0.2,2.67,0.07c0.73,0.27,1.31,0.66,1.77,1.18c0.45,0.52,0.8,1.12,1.03,1.8c0.23,0.68,0.36,1.21,0.47,1.81
					c0.07,0.39,0.1,1.01,0.07,1.46c-0.03,0.45-0.28,0.88-0.67,0.94L201.98,193.34z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            class="st1"
            d="M216.63,191.3c-0.09,0.1-0.09,0.26,0.02,0.31c0.7,0.3,1.54,0.9,1.86,1.6c0.43,0.94,0.43,1.71,0.43,2.48
					c0,0.6-0.54,1.12-0.74,1.69c-0.2,0.57-0.47,1.11-0.8,1.63c-0.34,0.52-0.72,1-1.16,1.44c-0.44,0.44-0.9,0.83-1.38,1.15
					c-0.6,0.42-1.24,0.77-1.9,1.06c-0.66,0.29-1.34,0.54-2.03,0.76c-0.69,0.21-1.39,0.39-2.09,0.53c-0.25,0.05-0.49,0.1-0.73,0.15
					c-0.74,0.15-1.35-0.36-1.37-1.14l-0.42-17.1c-0.02-0.69,0.5-1.36,1.15-1.5c0.63-0.13,1.28-0.26,1.95-0.4
					c1.08-0.22,2.12-0.33,3.11-0.34c0.99-0.01,1.9,0.15,2.72,0.48c0.83,0.33,1.48,0.93,1.96,1.8c0.5,0.9,0.66,1.9,0.49,2.99
					C217.54,189.87,217.23,190.63,216.63,191.3z M210.5,188.56l0.07,2.64c0.01,0.24,0.23,0.37,0.44,0.26
					c0.6-0.32,1.18-0.73,1.74-1.21c0.38-0.32,0.67-0.63,0.88-0.91c0.32-0.44,0.25-0.91-0.18-1.07c-0.18-0.07-0.4-0.11-0.66-0.14
					c-0.53-0.06-1.17-0.05-1.93,0.01C210.67,188.15,210.5,188.35,210.5,188.56z M210.77,198.21c0,0.29,0.26,0.46,0.53,0.34
					c0.62-0.29,1.26-0.64,1.91-1.05c0.48-0.3,0.91-0.65,1.29-1.04c0.45-0.47,0.34-1.24-0.22-1.35c-0.23-0.04-0.5-0.07-0.8-0.08
					c-0.71-0.02-1.47,0-2.29,0.08c-0.25,0.02-0.46,0.27-0.46,0.54L210.77,198.21z"
          />
        </g>
      </g>
    </g>
    <path
      class="st11"
      d="M173.67,142.53c0.16,2.88,3.7,5.71,3.92,0.54c0.22-5.17-0.82-6.96-1.96-7.02
		C174.49,136,173.45,138.56,173.67,142.53z"
    />
    <path class="st21" d="M174.43,44.99c-1.87-7.72-12.3-12.54-25.21-9.85c-16.74,3.49-37.97,5.08-65.21-7.56" />
    <path
      class="st21"
      d="M214.3,38.82c5.05-7.3,7.02-19.94-4.35-24.99c-12.25-5.44-33.24,4.14-49.7,11.9s-46.75,3.54-65.56-8.53"
    />
    <path class="st21" d="M201.52,39.94c0.01-5.47-1.66-15.75-13.76-15.02C174.76,25.7,146.35,53,95.53,44.71" />
    <g>
      <g>
        <path
          class="st16"
          d="M316.08,72.56c-4.53-0.16-9.17,2.61-15.94,1.36c-6.64-1.23-22.64-5.54-33.26-5.9
				c-0.21-0.05-0.41-0.06-0.6-0.03c-2.61,0.51-2.82,8.77-0.46,18.46c2.36,9.68,6.39,17.12,9.01,16.61c0.65-0.13,1.16-0.74,1.51-1.74
				c-0.35,1-0.85,1.61-1.51,1.74C285.09,100.59,291.01,92.79,302,91c3,3,3.32,3.72,5.62,4.56c2.84,1.04,5.44,1.21,7.83,1.05
				c2.37-0.17,4.25-2.21,5.67-4.69c1.41-2.46,2.35-4.36,3.8-8.52c0.9-2.59,12.2,0.24,14.4-5.44c1.74-4.5-1.74-7.44-4.55-6.45
				C330.64,72.96,319.22,72.67,316.08,72.56z"
        />
        <g>
          <defs>
            <path
              id="SVGID_5_"
              d="M300.14,73.91c6.77,1.25,11.41-1.52,15.94-1.36c2.14,0.08,20.58-3.55,23.81-0.06
						c0.38,10.59-5.23,8.42-14.53,9.03c-0.06,0.6-0.2,1.22-0.43,1.87c-1.45,4.16-2.39,6.06-3.8,8.52c-1.42,2.48-3.3,4.53-5.67,4.69
						c-2.4,0.17-4.99,0-7.83-1.05c-2.3-0.84-4.18-2.63-6.65-4.75c-10.99,1.79-15.87,9.78-26.13,12.24c-2.86,0.43-6.53-5.2-8.84-14.9
						"
            />
          </defs>
          <clipPath id="SVGID_6_">
            <use xlink:href="#SVGID_5_" style="overflow: visible" />
          </clipPath>
          <path
            class="st22"
            d="M264.19,90c10.63,1.02,26.18-2.74,30.33-3.31c4.15-0.56,10.19-1.34,12.5,0.16
					c2.3,1.49,12.33,6.6,15.41,1.75c1.65-2.61,0.95-8.54-0.03-11.1c3.83,0.09,14.07,1.58,14.05-5.8c1.08,0.06,3.99,2.16,3.54,3.7
					c-0.45,1.53-23.34,32.32-23.34,32.32l-14.89-9.86l-30.58,9.27L264.19,90z"
          />
        </g>
      </g>
      <path
        class="st23"
        d="M274.84,103.05c10.25-2.47,17.32-10.56,25.61-11.97c2.08-0.35,4.87,3.63,7.17,4.48
			c2.84,1.04,5.44,1.21,7.83,1.05c2.37-0.17,4.25-2.21,5.67-4.69c1.41-2.46,3.32-6.12,3.21-10.89c3.26,0.7,13.88,2.48,15.44-5.18
			c1.74-8.48-10.07-4.42-17.32-2.99c-2.11,0.42-4.2-1.3-10.04-0.54c-3.48,0.46-6.88,2.59-12.27,1.59
			c-6.64-1.23-22.64-5.54-33.26-5.9c-0.21-0.05-0.41-0.06-0.6-0.03c-2.61,0.51-2.82,8.77-0.46,18.46c2.36,9.68,6.1,17.17,8.71,16.66
			L274.84,103.05z"
      />
    </g>
    <g>
      <g>
        <g>
          <path
            d="M224.01,74.53c-1.81,0.16-3.48-2.07-3.73-4.97c-0.11-1.22,0.05-2.36,0.4-3.29c-0.32-0.54-1.38-2.13-2.43-2.38
					c-0.37-0.08-0.48-0.32-0.42-0.55c0.08-0.35,0.42-0.39,0.74-0.36c1.13,0.11,2.23,1.1,2.94,1.88c0.25-0.27,0.52-0.48,0.82-0.63
					c-0.11-0.82-0.38-2.06-1.05-2.57c-0.3-0.23-0.3-0.49-0.16-0.68c0.22-0.28,0.54-0.18,0.83-0.02c1.06,0.6,1.62,2.12,1.89,3.12
					c0.27,0.07,0.52,0.19,0.76,0.36c0.21-0.79,0.45-2.12,0-2.87c-0.2-0.33-0.1-0.57,0.1-0.69c0.32-0.19,0.57,0.03,0.78,0.28
					c1.17,1.46,0.46,4.47,0.42,4.55c-0.01,0.03-0.03,0.06-0.06,0.09c0.52,0.86,0.88,1.96,0.98,3.18
					C227.08,71.89,225.82,74.37,224.01,74.53z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M195.44,79.99c-1.88,0.16-3.63-2.16-3.89-5.19c-0.1-1.16,0.03-2.26,0.33-3.18c-0.09-0.07-0.16-0.17-0.21-0.28
					c0-0.01-1.28-2.26-2.54-2.56c-0.37-0.09-0.48-0.33-0.42-0.55c0.09-0.36,0.42-0.39,0.74-0.36c1.3,0.13,2.58,1.41,3.24,2.21
					c0.18-0.23,0.37-0.42,0.58-0.57c-0.07-0.73-0.32-2.36-1.1-2.96c-0.31-0.23-0.31-0.49-0.17-0.68c0.23-0.29,0.55-0.18,0.83-0.02
					c1.08,0.61,1.64,2.15,1.9,3.16c0.27,0.01,0.54,0.06,0.8,0.17c0.19-0.8,0.37-2.02-0.05-2.72c-0.19-0.34-0.1-0.58,0.1-0.69
					c0.32-0.19,0.58,0.02,0.78,0.28c0.92,1.15,0.68,3.26,0.51,4.15c0.8,0.94,1.37,2.37,1.51,4
					C198.64,77.23,197.33,79.82,195.44,79.99z"
          />
        </g>
      </g>
    </g>
  </g>
</svg>
